const API_BASE_URL = 'https://vendor-score.finkraftai.com';

export const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    // Redirect to login if no token is found
    window.location.href = '/login';
    return;
  }

  const defaultHeaders = {
    'Authorization': `Bearer ${token}`,
  };

  // Only add Content-Type if it's not FormData
  if (!(options.body instanceof FormData)) {
    defaultHeaders['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: 'include',
  });

  if (response.status === 401) {
    // Token is invalid or expired
    localStorage.removeItem('token');
    window.location.href = '/login';
    return;
  }

  return response;
}; 